import { takeEvery } from "redux-saga/effects";
import { RESULT_MORE } from "actions/const";
import { fetchResultAsync } from "./search";

/**
 * Watcher for RESULT_MORE
 */
export function* watchResultMore() {
  yield takeEvery(RESULT_MORE, fetchResultAsync, "append");
}
